function parseUnit(value) {
  if (typeof value === "string") {
    if (value.endsWith("rem")) {
      return "rem";
    }
    throw new Error("Unsupported font size unit");
  }
  return "px";
}
function parseNumericValue(value, unit) {
  if (unit === void 0) return 0;
  return typeof value === "string" ? Number.parseFloat(value.substring(0, value.lastIndexOf(unit))) : value;
}
function formatRemValue(pixelNumber, htmlFontSize, maxPrecision) {
  const remValue = pixelNumber / htmlFontSize;
  if (maxPrecision !== void 0) {
    return `${remValue.toFixed(maxPrecision)}rem`;
  }
  return `${remValue}rem`;
}
function parseNumericPixelValue(value, htmlFontSize) {
  const unit = parseUnit(value);
  const rawValue = parseNumericValue(value, unit);
  switch (unit) {
    case "px":
      return rawValue;
    case "rem":
      return rawValue * htmlFontSize;
    default:
      throw new Error("Unexpected value");
  }
}
export {
  formatRemValue,
  parseNumericPixelValue
};
//# sourceMappingURL=fontSize.js.map
